import { useEffect, useState } from "react";
import type { AuthedBlobRequester } from "@/lib/brokerAuth";

/** Bearer-authenticated images need a blob URL; an img src cannot send the token. */
export function useCarrierLogo(
  fetchBlob: AuthedBlobRequester,
  path: string | null | undefined,
): string | null {
  const [logo, setLogo] = useState<{ path: string; url: string } | null>(null);
  useEffect(() => {
    if (!path) return;
    let cancelled = false;
    let url: string | null = null;
    void fetchBlob(path)
      .then((file) => {
        if (cancelled) return;
        url = URL.createObjectURL(file.blob);
        setLogo({ path, url });
      })
      .catch(() => {
        if (!cancelled) setLogo(null);
      });
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fetchBlob, path]);
  return logo && logo.path === path ? logo.url : null;
}
